module.exports = __webpack_public_path__ + "static/media/service_top.4f109499.jpg";